<template>
  <div v-if="product && productPrice" class="f-col items-start gap-4">
    <pdp-section-heading-title />
    <pdp-section-heading-details />
    <slot name="espot-below-pricing" />
  </div>
</template>

<script lang="ts" setup>
import type { Slots } from '#commerce/types/pdp'

defineSlots<Pick<Slots, 'espot-below-pricing'>>()

const { product, productPrice } = usePdp()
</script>
